"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reqrepov3PatientDtoGenderEnum = exports.Reqrepov3PatientDtoEthnicityEnum = void 0;
exports.Reqrepov3PatientDtoEthnicityEnum = {
    Unknown: 'Unknown',
    AshkenaziJewish: 'Ashkenazi Jewish',
    Asian: 'Asian',
    BlackAfricanAmerican: 'Black/African-American',
    FrenchCanadian: 'French Canadian',
    Hispanic: 'Hispanic',
    Mediterranean: 'Mediterranean',
    NativeAmerican: 'Native American',
    PacificIslander: 'Pacific Islander',
    SephardicJewish: 'Sephardic Jewish',
    WhiteCaucasian: 'White/Caucasian',
    Other: 'Other'
};
exports.Reqrepov3PatientDtoGenderEnum = {
    Unknown: 'Unknown',
    Male: 'Male',
    Female: 'Female'
};
